<template>
  <b-overlay :show="!application">
    <vueCustomScrollbar
      class="scroll-area p-2"
      :settings="{wheelSpeed:0.5}"
      v-if="application"
    >
      <h3 class="mb-3">Application details</h3>
      <p>
        <b>id:</b> {{aid}}<br>
        <b>title:</b> {{application.data().name}}<br>
        <b>OS:</b> {{application.data().OS}}<br>
        <b>package_name:</b> {{application.data().package_name}}<br>
        <b>date:</b> {{application.data().date.toMillis() | moment('lll')}}<br>
      </p>    
    </vueCustomScrollbar>
  </b-overlay>
</template>

<script>
import firebase from 'firebase';
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'applicationDetail',
  props:{
    aid:{
      type:String,
      required:true,
    }
  },
  components: {
    vueCustomScrollbar,
  },
  data:function(){
    return {
      application:null,
    }
  },
  watch:{
    aid:{
      handler:function() {
        this.application = null;
        firebase.firestore()
          .collection("applications")
          .doc(this.aid)
          .onSnapshot((application)=>{
            this.application = application;
          });
      },
      immediate:true,
    }
  }
}
</script>
<style scoped>
.scroll-area{
  height: 100vh !important;
}
.scroll-area.ps--active-y{
  padding-right: 12px !important;
}
p{
  word-break: break-all;
}
</style>